import { Component } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'lfw-form-view-toolbar',
  template: `
    <mat-toolbar class="secondary" color="primary">
      <div class="wrap">
        <div class="left">
          <ng-content select="[toolbar-left]" />
        </div>
        <div class="center">
          <ng-content select="[toolbar-center]" />
        </div>
      </div>
      <div class="right">
        <ng-content select="[toolbar-right]" />
      </div>
    </mat-toolbar>
  `,
  styles: `
    :host {
      display: flex;
      justify-content: stretch;
      width: 100%;
      flex-basis: 1;
    }

    @media (width < 48rem) {
      .right {
        justify-content: flex-end;
        width: 100%;
        margin-left: 24px;
        padding-top: 12px;
        flex-shrink: 2;
      }
    }

    .wrap {
      display: flex;
      flex-grow: 2;
      justify-content: stretch;
      flex-wrap: wrap;
      align-items: center;
      margin-left: 12px;
      padding-top: 5px;
      padding-bottom: 5px;
    }
    .small-menu {
      flex-direction: column;
    }

    .left {
      display: flex;
      margin-right: 16px;
    }

    .center {
      display: flex;
      flex-grow: 2;
      justify-content: space-between;
      align-items: center;
    }

    .right {
      display: flex;
      justify-self: flex-end;
      margin-right: 12px;
      align-self: center;
      align-items: center;
    }
    ::ng-deep .spacer {
      flex: 1 1 auto;
    }
  `,
  imports: [MatToolbarModule]
})
export class FormViewToolbarComponent {}
